import Vue from 'vue'

import Portal from './layouts/Portal.vue'
import Empty from './layouts/Empty.vue'
import Login from './layouts/Login.vue'

Vue.component('portal', Portal);
Vue.component('empty', Empty);
Vue.component('login', Login);